import { AssetStoryblok } from '../../types/generated-storyblok';
import { Image } from '../Image';

type Props = {
  image: AssetStoryblok;
  label: string;
  onClick: () => void;
};

export const ProductRelatedDigitalProducts = ({
  image,
  label,
  onClick = () => {},
}: Props) => {
  return (
    <button
      className="link group flex w-full items-center gap-x-3 overflow-hidden rounded-sm border border-divider/20 p-3 text-left text-sm"
      onClick={onClick}
      type="button"
    >
      {image && (
        <span className="w-9 shrink-0">
          <Image
            alt={image?.alt || ''}
            hoverEffect
            shape="rounded"
            src={image.filename}
            width={32}
          />
        </span>
      )}
      <span className="w-full py-1">{label}</span>
    </button>
  );
};
